import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import './styles.scss';

const LoadingContainer: React.FC<Props> = ({ isLoading }) => {
  if (!isLoading) return null;

  return null;
  // return (
  //   <View className="ctn-loading">
  //     <Loading loadingStyle={4} />
  //   </View>
  // );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingContainer);
